import { memo, useState, useEffect, useCallback } from 'react';
import { BzChip, BzInputText, BzModal, BzModalBody, BzModalHeader, BzButton, } from "../../components";
import { Container, Col, Row } from 'react-bootstrap';
import TabsScripsList from '../Search/TabsScripsList';
import { searchFailure, getSearchScrips } from '../../redux/actions/globalSearch';
import { useDispatch, useSelector } from 'react-redux';
import { GLOBAL_SEARCH_MIN_LENGTH, MAX_SEARCH_SCRIP_PER_PAGE, ORDER_ENTRY_BUTTON_TOGGLE, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { useDebounce } from '../../hooks';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getExchangeWiseScripInfo, getScripOrderInfo, getSpreadOrder, updateIsBuyOrSell } from '../../redux/actions/orders';
import { isUserIsAGuest, ORDER_ENTRY_GRID_REF, getApiExchangeNameFromMktSegId, getMappedMktSegIdFromApiExchangeName } from '../../utils/global_functions';
import { toastConfig } from '../../redux/actions/toast';


const AddScripToActiveWatchlistModal = ({ scripsSearchValue, setScripsSearchValue,
    onHandleDone, scripDetails, activeWatchList,
    addScripsToSelectedWatchlist, removeScripsFromSelectedWatchlist, handleScripDetails, ...props }) => {


    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const recommendations = useSelector(state => state.recommendation.recommendations);
    const arrHotPursuitData = useSelector(state => state?.news?.arrHotPursuitData);
    const [isSearchScrips, setIsSearchScrips] = useState(false);
    const [arrRecommendationScrips, setArrRecommendationScrips] = useState([]);
    const objCFT = useSelector(state => state?.auth?.objCFT);

    //Ameersha N - 20-11-2023 - BT-95888 - Breeze- Create Watchlist - Start
    const handleTrendOrRecoClikc = (companyName) => {
        const strGlobalSearchText = companyName?.toUpperCase();
        setScripsSearchValue(strGlobalSearchText);
        if (companyName.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useDebounce(() => {
                dispatch(getSearchScrips(companyName, -1, 0, MAX_SEARCH_SCRIP_PER_PAGE, true));
            }, 1000);
        } else { }
    };
    //Ameersha N - 20-11-2023 - BT-95888 - Breeze- Create Watchlist - End



    useEffect(() => {
        if (recommendations?.length) {
            const arrRecommendations = {};
            const recommedationScrip = recommendations.filter((each) => {
                const objKey = each['companyName'];
                if (!arrRecommendations.hasOwnProperty(objKey)) {
                    arrRecommendations[objKey] = true;
                    return true;
                }
                return false;
            });
            setArrRecommendationScrips(recommedationScrip);
        }
    }, [recommendations]);
    const onChangeScripSearch = (e) => {
        const strGlobalSearchText = e?.target?.value?.toUpperCase();
        setScripsSearchValue(strGlobalSearchText);
        if (e.target.value.length >= GLOBAL_SEARCH_MIN_LENGTH) {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            useDebounce(() => {
                dispatch(getSearchScrips(e.target.value, -1, 0, MAX_SEARCH_SCRIP_PER_PAGE, true));
            }, 1000);
        } else { }
    };

    useEffect(() => {
        if (!scripsSearchValue || scripsSearchValue?.length < GLOBAL_SEARCH_MIN_LENGTH) {
            setIsSearchScrips(false);

        } else {
            setIsSearchScrips(true);
        }
    }, [scripsSearchValue]);

    const onHide = useCallback(() => {
        handleScripDetails();
        dispatch(handleModal([{ 'ADD_SCRIPT_ACTIVE_WATCHLIST_MODAL': false }]));
        setScripsSearchValue('');
        dispatch(searchFailure([]));
    }, [handleScripDetails, setScripsSearchValue, dispatch]);


    // Ameersha N : 04-01-2024 : BT-95888 : Create Watchlist- Start
    const handleSelectSpreadOrderModel = (spreadArr, strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
        var spreadPaylod =
        {
            "mktSegid": getMappedMktSegIdFromApiExchangeName(getApiExchangeNameFromMktSegId(spreadArr[WATCHLIST_GRID_INDEX.SEGMENT_ID])),//Ameersha N - 04-03-2024 - Sending Mapped Market Segment ID for spread API,
            "symbol": spreadArr[WATCHLIST_GRID_INDEX.SYMBOL],
            "token": spreadArr[WATCHLIST_GRID_INDEX.TOKEN]
        };
        dispatch(getSpreadOrder(spreadPaylod));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }, true]));
        const objScrpinfo = { activeExchangeId: '', isBuySell: 0, scripData: spreadArr };
        dispatch(getScripOrderInfo(objScrpinfo));
        //BT-135024 : Regression - Bug Fixing - Global Search : To restrict opening single scrip insteadof spread : ManasaB : 14-05-2024 - Start
        setTimeout(() => {
            dispatch(handleModalData({ data: { spreadArr: spreadArr, orderEntryTab: 'multi_scrip', activeTabKey: 'spread' } }), true);
        }, 10);
        //BT-135024 : Regression - Bug Fixing - Global Search : To restrict opening single scrip insteadof spread : ManasaB : 14-05-2024 - End
    };
    // Ameersha N : 04-01-2024 : BT-95888 : Create Watchlist- End
    // Ameersha N : 04-01-2024 : BT-95888 : Create Watchlist- Start
    const handlePlaceOrder = useCallback((orderInfo, nIsBuyOrSell) => {
        ORDER_ENTRY_GRID_REF.current.setIsScripPrice(false);
        dispatch(getScripOrderInfo({ isBuySell: nIsBuyOrSell, activeExchangeId: orderInfo[WATCHLIST_GRID_INDEX.EXCHANGE], scripData: orderInfo }));
        dispatch(handleModal([{ 'ORDER_ENTRY_MODAL': true }]));
    }, [dispatch]);
    // Ameersha N : 04-01-2024 : BT-95888 : Create Watchlist- End
    // Ameersha N : 04-01-2024 : BT-95888 : Create Watchlist- Start
    const onBuySellClick = useCallback((strBuySell, arrRowData) => {


        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - Start
                if (objCFT?.MULTILEG) {
                    handleSelectSpreadOrderModel(arrRowData, strBuySell);
                }
                else {
                    dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                }
                //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - End
            } else {
                handlePlaceOrder(arrRowData, strBuySell.toUpperCase() === 'BUY' ? ORDER_ENTRY_BUTTON_TOGGLE.BUY : ORDER_ENTRY_BUTTON_TOGGLE.SELL);
                dispatch(getExchangeWiseScripInfo(arrRowData));
            }

            setScripsSearchValue('');

        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End



        onHide();
    }, [handlePlaceOrder, onHide, handleSelectSpreadOrderModel, dispatch]);
    // Ameersha N : 04-01-2024 : BT-95888 : Create Watchlist- End






    return (
        <BzModal show={modals['ADD_SCRIPT_ACTIVE_WATCHLIST_MODAL']} onHide={onHide} className='p-3'>
            <BzModalHeader className='p-0'>
                <Container fluid className='p-3'>
                    <Row className='g-0 align-items-center'>
                        <Col>
                            <div className='input-group no-focus-textbox'>
                                <BzInputText className='font-regular form-control scripname-searchtext bdr-none' size='sm' value={scripsSearchValue} onChange={onChangeScripSearch} placeholder="Search scrips to add..." />
                            </div>
                        </Col>
                        {scripsSearchValue?.length >= 3 ? <Col md={1} className='ps-2'><span className='font-medium color-text' onClick={() => { setScripsSearchValue(''); }}>Clear</span></Col> : null}

                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={onHide}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='p-0'>
                {
                    scripsSearchValue && scripsSearchValue?.length >= GLOBAL_SEARCH_MIN_LENGTH ?
                        <TabsScripsList isKeyboard={false} onBuySellClick={onBuySellClick} isDefaultAllTab={true} strWatchlistName={activeWatchList?.sWatchListName} scripDetails={scripDetails} isSearchScrips={true} strSearchInputText={scripsSearchValue}
                            onHandleDone={onHandleDone} addScrips={addScripsToSelectedWatchlist} removeScrips={removeScripsFromSelectedWatchlist} />
                        :
                        <Container fluid className='p-3'>
                            <div className='pb-3'>
                                <Row className='g-0 mb-3'>
                                    <Col className='d-flex align-items-center'>
                                        <div className='icon-16 icon-recommendations-fill icon-dark me-3'></div>
                                        <div className='font-medium font-size3 color-text'>Recommendations</div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col>
                                        <div className='chips-wrap'>
                                            {arrRecommendationScrips?.map((each) => (
                                                <BzChip className='multi-chip mb-3 me-3' key={each.id}
                                                    onClick={() => handleTrendOrRecoClikc(each.companyName)}//Ameersha N - 20-11-2023 - BT-95888 - Breeze- Create Watchlist  : Issue-Searching scrips of recoomended
                                                >{each.companyName}</BzChip>
                                            ))}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='pb-3'>
                                <Row className='g-0 mb-3'>
                                    {arrHotPursuitData?.length > 0 &&
                                        <>
                                            <Col className='d-flex align-items-center'>
                                                <div className='icon-16 icon-trending icon-dark me-3'></div>
                                                <div className='font-medium font-size3 color-text'>Trending</div>
                                            </Col>
                                        </>
                                    }
                                </Row>
                                <Row className='g-0'>
                                    {arrHotPursuitData?.length > 0 &&

                                        <Col>
                                            <div className='chips-wrap'>
                                                {arrHotPursuitData?.map((each) => (
                                                    <BzChip className='multi-chip mb-3 me-3' key={each.id}
                                                        onClick={() => handleTrendOrRecoClikc(each?.symbol)}//Ameersha N - 20-11-2023 - BT-95888 - Breeze- Create Watchlist  : Issue-Searching scrips of hotpursuit
                                                    >{each.symbol}</BzChip>
                                                ))}
                                            </div>
                                        </Col>
                                    }
                                </Row>
                            </div>
                            <form className='d-flex' onSubmit={(e) => e?.preventDefault()}>
                                <Container fluid className='p-0 pt-3 bdr-top'>
                                    <Row className='g-0'>
                                        <Col md={10} className='d-flex justify-content-start align-items-start'>
                                            <div className='font-regular font-size3 color-subtext text-nowrap me-2'>Add Scrip To </div>
                                            <div className='font-medium font-size3 color-text text-uppercase me-2'>{activeWatchList?.sWatchListName} <span className='number-badge ms-2'>{scripDetails?.length}</span></div>
                                        </Col>
                                        <Col md={2} className='d-flex justify-content-end align-items-center'>
                                            <BzButton className='btn btn-md btn-block btn-primary text-uppercase' onClick={onHandleDone} disabled={true}>Done</BzButton>
                                        </Col>
                                    </Row>
                                </Container>
                            </form>
                        </Container>
                }
            </BzModalBody>
        </BzModal>
    );
};

export default memo(AddScripToActiveWatchlistModal);